import * as yup from 'yup'

export const schema = yup.object({
   ufContrato: yup
      .mixed<'PR' | 'ES'>()
      .oneOf(['PR', 'ES'])
      .required('O campo UF do Contrato é obrigatório'),

   cnpjAgenteFinanceiro: yup
      .string()
      .required('O campo CNPJ é obrigatório'),

   numeroContrato: yup
      .string()
      .required('O campo Nº do Contrato é obrigatório'),

   chassi: yup
      .string()
      .when('ufContrato', {
         is: 'ES',
         then: yup.string().required('O campo Chassi é obrigatório para ES'),
         otherwise: yup.string().nullable()
      }),

   numeroAditivo: yup.string().nullable()
})